var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1916B0",
  d: "M.5 7.5H18m0 0L11.77 1M18 7.5 11.77 14"
})));
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBkPSJNMC41IDcuNUgxOE0xOCA3LjVMMTEuNzY5MiAxTTE4IDcuNUwxMS43NjkyIDE0IiBzdHJva2U9IiMxOTE2QjAiIC8+Cjwvc3ZnPg==";